import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import {
    FormLanguageProvider,
    LocalizedFormInputFields,
    LocalizedFormTextareaFields,
    NumberInputField,
} from '@mews-commander/form';
import { FormInputField, lt } from '@mews/framework';
import { Stack } from '@optimus-web/core';
import { getSortedLanguages } from '@mews-commander/legacy-entities/src/ducks/languages';
import { useCommanderSelector } from '@mews-commander/utils';
import { DetailsFieldName } from '../../types';

interface RateGroupFormDetailFieldsProps {
    initialLanguageCode?: string;
    disableRateGroupKeyEditing?: boolean;
}

export const RateGroupFormDetailFields = ({
    initialLanguageCode,
    disableRateGroupKeyEditing = false,
}: RateGroupFormDetailFieldsProps) => {
    const { defaultLanguageCode } = useCurrentEnterprise();
    const languages = useCommanderSelector(getSortedLanguages);

    return (
        <FormLanguageProvider
            initialLanguageCode={initialLanguageCode}
            defaultLanguageCode={defaultLanguageCode}
            languages={languages}
        >
            <Stack vertical spacing="300" fill>
                <LocalizedFormInputFields autoFocus required name={DetailsFieldName.Names} label={lt('Name')} />
                <LocalizedFormInputFields name={DetailsFieldName.ShortNames} label={lt('ShortName')} />
                <LocalizedFormTextareaFields name={DetailsFieldName.Descriptions} label={lt('Description')} />
                <FormInputField
                    label={lt('RateGroupKey')}
                    name={DetailsFieldName.RateGroupKey}
                    helper={lt('RateGroupKeyFieldHelper')}
                    disabled={disableRateGroupKeyEditing}
                />
                <NumberInputField
                    label={lt('Ordering')}
                    name={DetailsFieldName.Ordering}
                    helper={lt('RateGroupOrderingFieldHelper')}
                />
            </Stack>
        </FormLanguageProvider>
    );
};
